// extracted by mini-css-extract-plugin
export default {"cls1":"fQpLWIIHey05zd2SxwAE","cls2":"ZlvOBl7_LjnkusegMWZV fQpLWIIHey05zd2SxwAE"};